var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-locale-provider',{attrs:{"locale":_vm.locale}},[_c('div',{class:{'full-screen': _vm.spinning },attrs:{"id":"app"}},[_c('Spin',{attrs:{"spinning":_vm.spinning,"size":"large","tip":"Loading..."}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }